import React from 'react';
import { LayoutError } from '../../components/errors/scopes/layout/layoutError';
import Page from '../../components/page/page';
import { useHttpError } from '../../hooks/useHttpError';
import { useHistory } from 'react-router-dom';
import { ErrorCodes, NonAuthRoutes } from '../../model';

export interface UnauthorizedPageProps {
  logoutHandler: () => void;
  email: string;
}

export const UnauthorizedPage: React.FC<UnauthorizedPageProps> = ({
  logoutHandler,
  email
}) => {
  let history = useHistory();
  const { showError, errorProps } = useHttpError();

  React.useEffect(() => {
    showError({
      errorCode: ErrorCodes.UNAUTHORIZED,
      onRefresh: () => {
        history.push(NonAuthRoutes.home);
      },
      onLogout: () => {
        logoutHandler();
      },
      email: email
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Page fullWidth={false}>
      <LayoutError {...errorProps}></LayoutError>
    </Page>
  );
};
